import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { APP_CONTEXT } from 'src/app/modules/core/models/app-state';
import { SignalRHubService } from 'src/app/modules/core/services';
import { AppStateService } from 'src/app/modules/core/services/app-state.service';
import { TranslateModule } from '@ngx-translate/core';
import { UserComponent } from './user/user.component';
import { GarageComponent } from './garage/garage.component';
import { TopBarSearchComponent } from './top-bar-search/top-bar-search.component';
import { ConnectingAnimatingIconComponent } from '../../modules/shared/components/connecting-animating-icon/connecting-animating-icon.component';

import { ConfigService } from 'src/config';

@Component({
    selector: 'app-top-bar',
    templateUrl: './top-bar.component.html',
    styleUrls: ['./top-bar.component.scss'],
    imports: [
        ConnectingAnimatingIconComponent, TopBarSearchComponent, GarageComponent, UserComponent, 
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class TopBarComponent implements OnInit, OnDestroy {
    private readonly _signalRHubService = inject(SignalRHubService);
    private readonly _appState = inject(AppStateService);
    private readonly _config = inject(ConfigService);

    public signalRConnected = undefined;
    public hideSearchBar = false;
    public environmentName = '';

    private _ngUnsubscribe$ = new Subject<void>();


    constructor() { }

    ngOnInit() {
        this.environmentName = this._config.environmentName;

        this._signalRHubService.isConnected$.pipe(
            takeUntil(this._ngUnsubscribe$)
        ).subscribe(connected => {
            this.signalRConnected = connected === undefined ? undefined : connected;
        });

        this._appState.getPropertyState('selectedContext')
            .pipe(
                takeUntil(this._ngUnsubscribe$)
            ).subscribe(selectedContext => {
                this.hideSearchBar = selectedContext === APP_CONTEXT.HISTORY;
            });
    }

    ngOnDestroy() {
        this._ngUnsubscribe$.next();
        this._ngUnsubscribe$.complete();
    }

    public setContext() {
        this._appState.changeContext(APP_CONTEXT.NONE);
    }
}
